import React, { useState } from "react";
import { Button, styled } from "@mui/material";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { ButtonBox, Input } from "./styles";
import { Toast } from "../components/Toast";

const ButtonCancel = styled(Button)({
  backgroundColor: "rgb(138, 138, 138) !important",
  color: "white",
  textShadow: "1px 1px 2px rgb(161, 161, 161)",
  boxShadow: "0px 1px 2px rgb(161, 161, 161)",
});

function AddItem({ onClose, onSuccess }) {
  const [newItem, setNewItem] = useState({
    name: "",
    saleQuantity: "",
    price: "",
  });

  const itemInput = (e) => {
    let { name, value } = e.target;
    setNewItem((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdd = () => {
    if (!newItem.name) {
      Toast("info", "Add name");
      return;
    }
    if (!newItem.saleQuantity) {
      Toast("info", "Add Sale Quantity");
      return;
    }
    if (!newItem.price) {
      Toast("info", "Add Price");
      return;
    }
    newItem.saleQuantity = Number(newItem?.saleQuantity)
    newItem.price = Number(newItem?.price)

    onSuccess(newItem);
  };
  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing={2}>
          <Typography
            variant="h6"
            sx={{ color: "#4EAF51", textAlign: "center" }}
          >
            Add New Item
          </Typography>

          <Input
            fullWidth
            size="small"
            variant="outlined"
            label="Item Name"
            name="name"
            value={newItem.name}
            onChange={itemInput}
          />

          <Input
            fullWidth
            size="small"
            variant="outlined"
            label="Quantity"
            name="saleQuantity"
            type="number"
            value={newItem.saleQuantity}
            onChange={itemInput}
          />

          <Input
            fullWidth
            size="small"
            variant="outlined"
            label="Price"
            name="price"
            value={newItem.price}
            onChange={itemInput}
          />

          <ButtonBox>
            <ButtonCancel fullWidth variant="contained" onClick={onClose}>
              Cancel
            </ButtonCancel>

            <Button fullWidth variant="contained" onClick={handleAdd}>
              Add Item
            </Button>
          </ButtonBox>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default AddItem;
